/* istanbul ignore file -- @preserve */
import { ApolloLink } from '@apollo/client';

import { getTeamKeyFromPath } from 'utils/teamFromUrl';

const sentinelTeamLink = new ApolloLink((operation, forward) => {
  const teamKey = getTeamKeyFromPath(window.location.pathname);

  if (teamKey) {
    operation.setContext(
      ({ headers = {} }: { headers?: Record<string, string> }) => ({
        headers: {
          ...headers,
          'X-DECISIV-SENTINEL-TEAM-KEY': teamKey,
        },
      }),
    );
  }

  return forward(operation);
});

export default sentinelTeamLink;
